import _ from 'lodash';

import { Box } from './Box';
import { Collision } from './Collision';
import { Column, ColumnItem } from './Column';
import { Position2D } from './Position2d';

export class LabelVisualOverlapping extends Collision {
  columns = [];
  index = 0;

  constructor (height, width) {
    super();

    this.create = this.create.bind(this);
    this.setBox = this.setBox.bind(this);
    this.getPointPosition = this.getPointPosition.bind(this);
    this.resetCreator = this.resetCreator.bind(this);
    this.setTextPositionY = this.setTextPositionY.bind(this);
    this.setPathPositionY = this.setPathPositionY.bind(this);

    this.setBox(new Box(5, width, 5, height - 70)); // - 80 HACK
  }

  resetCreator () {
    // console.log('Reseted');
    this.index = 0;
    this.columns = [];
  }

  prepareRender () {
  }

  setBox (box) {
    this.box = box;

    this.minY = box.y1;
    this.maxY = box.y2;

    this.minX = box.x1;
    this.maxX = box.x2;
  }

  create (label) {
    const createdLabel = label.createVisual(label.options);

    if (this.index++ % 3 === 2) {
      const textObj = _.find(createdLabel.children, i => i.nodeType === 'Text');
      if (!textObj) {
        return false;
      }
      const bbox = createdLabel.bbox();
      let basePosition = new Position2D(textObj._position.x, bbox.origin.y + (bbox.size.height / 2));
      let column = _.find(this.columns, i => Math.abs(i.index - basePosition.x) <= 10);

      if (!column) {
        column = new Column(basePosition.x, []);
        this.columns.push(column);
      }

      let columnItem = new ColumnItem(createdLabel, basePosition, this.getPointPosition(basePosition), bbox);
      column.items.push(columnItem);
      this.calculateColumnsPosition(this.columns);
    }
    return createdLabel;
  }

  getPointPosition (position) {
    return position.copy().addX(9).addY(16);
  }

  setTextPositionY (label, box) {
    _.find(label.children, i => i.nodeType === 'Text')._position.y = box.y1;
  }

  setPathPositionY (label, box) {
    const path = _.find(label.children, i => i.nodeType === 'Path');
    if (!path) {
      return;
    }

    path.segments[0]._anchor.y = box.y1;
    path.segments[1]._anchor.y = box.y1;
    path.segments[2]._anchor.y = box.y1 + 14;
    path.segments[3]._anchor.y = box.y1 + 14;
  }
}
